import React, { Component } from 'react';
import { Button, Toolbar } from 'react-md';
import '../Wizard.scss';
import Select from 'react-select';
import { ProgressBar } from '../../index';

class PersonWizardStep3 extends Component {
  state = {
    role: null,
    organizations: null,
    visible: true
  };

  componentDidMount() {
    const { data } = this.props;

    const role = data && data.relationships ?
      data.relationships[0].relationshipType.toLowerCase().split('_')
        .map((word) => ( word[0].toUpperCase() + word.substr(1))).join(' ') :
      null;

    const orgs = data && data.relationships ?
      data.relationships.map((rel) => {
        return {
          value: rel.fromPartyKey,
          label: rel.displayName,
          relationshipKey: rel.relationshipKey
        };
      }) :
      null;

    if (data) {
      this.setState({
        role: role && { value: role.toUpperCase(), label: role },
        organizations: orgs
      });
    }
  }

  handleRoleChange = (data) => {
    this.setState({ role: data, organizations: null });
    this.props.actions.update({
      newRelationshipType: data.value,
      currentRelationshipType: this.props.data && this.props.data.relationships ?
        this.props.data.relationships.relationshipType :
        null
    });
  }

  handleOrgChange = (data, props) => {
    this.setState({ organizations: data });
    const formattedData = data && data.map(x => {
      return {
        fromPartyKey: x.value,
        relationshipType: this.state.role.value,
        relationshipKey: x.relationshipKey && x.relationshipKey
      };
    });

    this.props.actions.update({ relationships: formattedData });
  }

  handleSubmit = async() => {
    const { hide, nextStep, data, editData, actions: { initRecursiveTree, confirmPerson } } = this.props;

    if (!data) {
      initRecursiveTree(editData.relationships);
      nextStep();
    }

    if (data) {
      confirmPerson(!!data, {
        edits: editData,
        original: data
      });
      hide();
    }
  }

  render() {
    const { role, organizations } = this.state;
    const { data, title, options, editData } = this.props;

    return (
      <div className="wrapper" ref={this.props.innerRef}>
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: '36px' }}
          title={data ? `Edit ${title.toLowerCase()}` : `Creating a new ${title.toLowerCase()}`}
          nav={<Button id="dialog-back-button" onClick={this.props.previousStep} icon >arrow_back</Button>}
          style={{ backgroundColor: '#6200EE' }}
        />
        <ProgressBar step={this.props.currentStep} steps={data ? 3 : 4} />
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">What role should they have?</div>
            <div className="wizard-step-subheader">This is the role they have when accessing ParkHub products, not necessarily their role and title within the company.</div>
          </div>
          <div className="wizard-select-container">
            <Select
              classNamePrefix="wizard-select"
              id="person-role-select"
              className="wizard-select"
              placeholder="Role"
              defaultValue={role}
              value={role}
              onChange={this.handleRoleChange}
              options={options.roleOptions}
            />
            <Select
              isMulti
              backspaceRemovesValue={false}
              isClearable
              isDisabled={!role}
              classNamePrefix="wizard-select"
              id={`person-organization-select`}
              className="wizard-select"
              placeholder="Organization"
              defaultValue={organizations}
              value={organizations}
              options={role ? options.userOrgOptions[role.value] : options.orgOptions}
              onChange={this.handleOrgChange}
            />
          </div>
          <div className="wizard-error">
            {editData && editData.relationships && editData.relationships.length < 1 ? 'Organization Required': true}
          </div>
          <div>
            <Button
              className="wizard-button"
              disabled={!role || !organizations || !editData ||(editData && editData.relationships && editData.relationships.length < 1)}
              flat
              onClick={this.handleSubmit}
              children={data ? 'confirm edits' : 'continue'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => <PersonWizardStep3 innerRef={ref} {...props} />);



// WEBPACK FOOTER //
// ./src/components/Wizard/PersonWizardStep3/PersonWizardStep3.jsx